/**
 * Icon sizes — the single source of truth for how big icons render in V3 blocks.
 *
 * Every block references these instead of hardcoding `size-6`/`size-5`/etc., so a
 * size change is ONE edit here and every block follows it. Values are Tailwind
 * size utilities: `size-4` = 16px, `size-5` = 20px, `size-8` = 32px.
 *
 * Sizes come from Figma. Add a new entry here (never a raw `size-N` in a block)
 * when a new icon appears.
 */
export const ICON_SIZE = {
    /** Custom (icon-picker) glyph inside a flip card — Figma 32px. */
    flipCardIcon: "size-8",
    /** Custom (icon-picker) glyph on a tab — Figma 20px. */
    tabIcon: "size-5",
    /** The dashed "+" placeholder inside an empty icon-picker box — Figma 20px. */
    pickerPlus: "size-5",
    /** The (i) before quiz feedback: follows its Small text (16px at 14px). */
    feedbackIcon: "size-[1.15em]",
    /** Site favicon (or globe) on the "can't be shown here" embed card. */
    embedSiteIcon: "size-6",
    /** The ↗ before "Open in new tab": follows its Label text. */
    embedOpenIcon: "size-[1.15em]",
} as const;
